// extracted by mini-css-extract-plugin
export default {"fullscreen":"wrapper_fullscreen__1jV9V"};